module.exports = __webpack_public_path__ + "img/company_icon4.8e18f158.png";